var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('p',{staticClass:"title is-size-5"},[_vm._v(" Pools Available for "+_vm._s(_vm.mapTokenSymbol(_vm.toTokenAddress))+" ")]),_c('p',{staticClass:"subtitle"},[_vm._v(" xxx ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }